import { useAuth } from "../context/AuthContext.jsx";

export function useRole() {
  const { role } = useAuth();
  return role;
}
